import React from 'react';

import {styled} from "@mui/material";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const FlexColumn = styled(Box)({
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
})

const CellTitle = styled(Box)(({theme}) => ({
    color: theme.palette.text.primary,
    fontSize: theme.typography.body2.fontSize,
    textAlign: "center"
}))

const CellValue = styled(Box)(({theme}) => ({
    fontWeight: 'medium',
    textAlign: "center",
    fontSize: theme.typography.h5.fontSize,
}));


const TextIconListElement = props => {
    const {iconComponent, iconSize, text, fontWeight} = props;
    const Icon = iconComponent;
    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Icon fontSize={iconSize || "small"}/>
            <Typography sx={{fontWeight: fontWeight}}>
                {text}
            </Typography>
        </Stack>
    );
}

const BookingAccommodationUnits = ({accommodations, booking, small, unitColor, accommodationColor}) => {

    const accommodationUnit = booking.bookingItems.length === 1 ?
        accommodations.findAccommodationUnit(booking.bookingItems[0].bookableType, booking.bookingItems[0].bookableId)
        : null

    const accommodationUnitText = accommodationUnit ? accommodationUnit.name : `${booking.bookingItems.length} strutture prenotate`

    return (
        <Box sx={{
            flexGrow: 1,
            ml: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
        }}>
            <Box
                sx={{
                    fontWeight: 'medium',
                    textAlign: "center",
                    fontSize: small ? 'h6.fontSize' : 'h5.fontSize',
                    color: unitColor || 'primary.main'
                }}>
                {accommodationUnitText}
            </Box>
            {
                accommodationUnit && <Box sx={{
                    color: accommodationColor || 'text.primary',
                    fontSize: small ? 'caption.fontSize' : 'body1.fontSize',
                    textAlign: "center"
                }}>
                    {accommodationUnit.accommodation.name}
                </Box>
            }
        </Box>
    )
}

const BookingPrice = ({price, payed, balance, sx}) => {
    return (
        <Stack direction="row"
               divider={<Divider orientation="vertical" flexItem/>}
               sx={{my: 2, ...sx}}>

            <FlexColumn>
                <CellTitle>
                    Totale
                </CellTitle>
                <CellValue>
                    {price ? `${price} €` : "--"}
                </CellValue>
            </FlexColumn>

            <FlexColumn>
                <CellTitle>
                    Pagato
                </CellTitle>
                <CellValue sx={{color: 'success.dark'}}>
                    {payed ? `${payed} €` : "--"}
                </CellValue>
            </FlexColumn>

            <FlexColumn>
                <Box sx={{flexGrow: 1}}>
                    <CellTitle>
                        Da pagare
                    </CellTitle>
                    <CellValue sx={{color: 'error.dark'}}>
                        {balance ? `${balance} €` : "--"}
                    </CellValue>
                </Box>
            </FlexColumn>
        </Stack>
    )
}

export {
    BookingAccommodationUnits,
    TextIconListElement,
    BookingPrice
};